import { render } from "./setfhiralert.vue?vue&type=template&id=6dc82ef9&scoped=true"
import script from "./setfhiralert.js?vue&type=script&lang=js"
export * from "./setfhiralert.js?vue&type=script&lang=js"

import "./setfhiralert.vue?vue&type=style&index=0&id=6dc82ef9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc82ef9"]])

export default __exports__